export const getTimeZone = () => {
  const { timeZone } = new Intl.DateTimeFormat().resolvedOptions()
  return timeZone
}
